<template>
  <section class="features">
    <div class="container">
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <v-lazy-image :src="$config.features.install_fast.icon" alt="install fast icon" width="105" height="91" />
          </div>
          <h3 class="feature-title">{{ $config.features.install_fast.title }}</h3>
          <p class="feature-description" v-html="$config.features.install_fast.description"></p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <img :src="$config.features.smart_accurate.icon" alt="smart accurate icon" width="105" height="91">
          </div>
          <h3 class="feature-title">{{ $config.features.smart_accurate.title }}</h3>
          <p class="feature-description" v-html="$config.features.smart_accurate.description"></p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <img :src="$config.features.full_coverage.icon" alt="full coverage icon" width="105" height="91">
          </div>
          <h3 class="feature-title">{{ $config.features.full_coverage.title }}</h3>
          <p class="feature-description" v-html="$config.features.full_coverage.description"></p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <img :src="$config.features.free_to_use.icon" alt="free to use icon" width="105" height="91">
          </div>
          <h3 class="feature-title">{{ $config.features.free_to_use.title }}</h3>
          <p class="feature-description" v-html="$config.features.free_to_use.description"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Features",
};
</script>

<style scoped>
.features {
  padding-top: 0;
  margin-top: -80px; /* 与Hero区域重叠更多 */
  position: relative;
  z-index: 3;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(40px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.feature-icon {
  margin-bottom: 20px;
  color: #0e3d45; /* 设置SVG图标颜色 */
}

.feature-icon svg {
  display: block;
  margin: 0 auto;
}

.feature-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #0e3d45;
}

.feature-description {
  font-size: 14px;
  color: #334e58;
  line-height: 1.6;
}

@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 576px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
